'use client'
import {
  __async,
  __spreadValues
} from "./chunk-BTG5EALA.mjs";

// src/api/forecast/condition.ts
import { useQuery } from "@tanstack/react-query";
import { Exception } from "@wbk/logger";
var getWeatherCondition = (_0) => __async(void 0, [_0], function* ({ city = "riyadh", lang }) {
  try {
    const locale = lang || "en";
    const res = yield fetch(
      `https://r2.webook.com/forecast/currentconditions/${locale}/${city}.json`
    );
    if (!res.ok) {
      throw new Error("Failed to fetch ForecastCondition");
    }
    const data = yield res.json();
    return data;
  } catch (error) {
    throw new Exception({ error, name: "getWeatherConditionException" });
  }
});
var useGetWeatherCondition = (props, options) => {
  return useQuery(__spreadValues({
    queryKey: ["getWeatherCondition", props],
    queryFn: () => getWeatherCondition(props),
    staleTime: Infinity,
    gcTime: Infinity
  }, options));
};

export {
  useGetWeatherCondition
};
//# sourceMappingURL=chunk-F7HCPT4F.mjs.map